var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-row',[_c('v-col',{attrs:{"cols":"24","lg":"12"}},[_c('contact-form',{attrs:{"name":_vm.name,"required-fields":_vm.requiredFields}},[_c('contact-fields',{attrs:{"exclude":_vm.exclude}})],1)],1),_c('v-col',{attrs:{"cols":"24","lg":"11","offset-lg":"1"}},[_c('contact-company-info')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }